import { isNative } from '@/services/platform';

// Гейт device-lock (биометрия/PIN/графический ключ). v1: на native — задел под плагин
// biometric/device-credential (подключим позже); на web/dev — заглушка (UI ведёт разблокировку).
export const deviceLock = {
  /** Доступна ли аппаратная блокировка (биометрия/PIN устройства). */
  isAvailable(): boolean {
    // TODO(P1+): @aparajita/capacitor-biometric-auth — проверка реальной доступности.
    return isNative();
  },

  /**
   * Запрос разблокировки. На native позже — нативный промпт; сейчас резолвит true,
   * фактический жест разблокировки даёт LockView (тап «Разблокировать»).
   */
  async authenticate(): Promise<boolean> {
    return true;
  },
};
